import ParseService from '~/services/parseService';
import Backbone from 'backbone';
/**
 * @member [Model.extend] Model
 */
var Model = {
    /**
     * Creates an Object from parseService with defined attributes.
     * @function extend
     * @param {dynamic} options
     * @returns [dynamic Model] which wraps Parse object
     * @memberOf Model
     */
    extend: function (options) {

        /**
         * Assigns className class with properties
         * @member [className] ParseModel
         */
        var ParseModel = Parse.Object.extend({
            className: options.className
        });

        /**
         * @returns Backbone.Model
         */
        return Backbone.Model
            .extend(options)
            .extend({
                /**
                 * copy properties from Parse.Object to Backbone.Model
                 * trigger a new instance of this model
                 * @function initialize
                 * @param options
                 * @memberOf Backbone.Model
                 */
                initialize: function (options) {
                    if (options instanceof ParseModel) {//validate it's ParseModelObject
                        Backbone.Model.prototype.set.apply(this, [options.attributes]); // copy properties from Parse.Object to Backbone.Model
                        this.set(options.attributes);
                        this.parseObject = options;
                    } else {
                        this.parseObject = new ParseModel();
                    }
                },
                /**
                 * updates Backbone model & update Parse model
                 * @function set
                 * @memberOf Backbone.Model
                 */
                set: function () {
                    Backbone.Model.prototype.set.apply(this, arguments); // update Backbone model
                    if (this.parseObject) {
                        this.parseObject.set.apply(this.parseObject, arguments); // update Parse model
                    }
                },
                /**
                 * saves parse model to server
                 * @function save
                 * @returns {boolean}
                 * @memberOf Backbone.Model
                 */
                save: function () {
                    return this.parseObject.save.apply(this.parseObject, arguments); // save parse model to server
                }
            });
    }
};
/**
 * This model will set an dynamic Backbone Model
 * @module models/parseModel
 * @returns [Backbone.Model]
 */
export default Model;